import styled from '@emotion/styled';
import { colorVariables} from '../base/theme';

type ColorKey = 'borderLighter' | 'borderLight' | 'borderMedium' | 'borderDark';
type Sizes = 'small' | 'medium' | 'large';

const sizes = {
    small: '1px',
    medium: '2px',
    large: '3px'
}

const Separator = styled.div<{ width?: string, colorKey?: ColorKey, size?: Sizes}>`
  height: ${({ size = 'small'}) => sizes[size]};
  width: ${({ width = '100%' }) => width};
  margin: 0;
  background-color: ${({ colorKey = 'borderMedium' }) => colorVariables[colorKey]};
`;

export default Separator;
